// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button-container {
  display: flex;
  justify-content: end;
  align-items: end;
}

.upload-button {
  padding: 10px 15px;
  font-size: 16px;
  margin: 18px;
  background-color: #fff;
  color: #004987;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  font-weight: 600;
}

.upload-icon {
  margin-left: 8px;
}

.upload-button:hover {
  background-color: #f3f3f3;
}

/* Add this SCSS to your fileuploader.scss or a separate SCSS file */
.table-container .table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}
.table-container .table th,
.table-container .table td {
  border: 1px solid #ddd;
  padding: 10px;
  text-align: left;
}
.table-container .table th {
  background-color: #f2f2f2;
}
.table-container .upload-button {
  /* Your existing styles for the button */
}
.table-container .upload-icon {
  /* Your existing styles for the upload icon */
}
.table-container .table-header {
  /* Styles for table header cells */
}
.table-container .action-buttons button {
  margin-right: 8px;
}

.sidebar {
  position: fixed;
  top: 69px;
  left: 0;
  height: 100%;
  width: 21%;
  background-color: #004987;
  transition: left 0.3s ease;
}
.sidebar .list-group-item {
  margin: 5px;
}

.sidebar-button-divs {
  background-color: #fff;
  margin: 5px;
  min-height: 45px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.sidebar-button-dropdown {
  flex-direction: column;
}`, "",{"version":3,"sources":["webpack://./src/components/upload/fileuploader.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,oBAAA;EACA,gBAAA;AADJ;;AAIA;EACI,kBAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;AADJ;;AAIA;EACI,gBAAA;AADJ;;AAIA;EACI,yBAAA;AADJ;;AAIA,oEAAA;AAII;EAEI,WAAA;EACA,yBAAA;EACA,gBAAA;AALR;AAOQ;;EAEI,sBAAA;EACA,aAAA;EACA,gBAAA;AALZ;AAQQ;EACI,yBAAA;AANZ;AAUI;EACI,wCAAA;AARR;AAWI;EACI,6CAAA;AATR;AAYI;EACI,kCAAA;AAVR;AAcQ;EACI,iBAAA;AAZZ;;AAiBA;EACI,eAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;EACA,UAAA;EAEA,yBAAA;EACA,0BAAA;AAfJ;AAiBI;EACI,WAAA;AAfR;;AAmBA;EACI,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAhBJ;;AAmBA;EACI,sBAAA;AAhBJ","sourcesContent":["// Folderupload.scss\n\n.button-container {\n    display: flex;\n    justify-content: end;\n    align-items: end;\n}\n\n.upload-button {\n    padding: 10px 15px;\n    font-size: 16px;\n    margin: 18px;\n    background-color: #fff;\n    color:#004987;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    font-weight: 600;\n}\n\n.upload-icon {\n    margin-left: 8px;\n}\n\n.upload-button:hover {\n    background-color: #f3f3f3;\n}\n\n/* Add this SCSS to your fileuploader.scss or a separate SCSS file */\n\n.table-container {\n\n    .table {\n\n        width: 100%;\n        border-collapse: collapse;\n        margin-top: 10px;\n\n        th,\n        td {\n            border: 1px solid #ddd;\n            padding: 10px;\n            text-align: left;\n        }\n\n        th {\n            background-color: #f2f2f2;\n        }\n    }\n\n    .upload-button {\n        /* Your existing styles for the button */\n    }\n\n    .upload-icon {\n        /* Your existing styles for the upload icon */\n    }\n\n    .table-header {\n        /* Styles for table header cells */\n    }\n\n    .action-buttons {\n        button {\n            margin-right: 8px;\n        }\n    }\n}\n\n.sidebar {\n    position: fixed;\n    top: 69px;\n    left: 0;\n    height: 100%;\n    width: 21%; // Adjust the width as needed\n    // background-color: #004987; // Set background color\n    background-color: #004987; // Set background color\n    transition: left 0.3s ease; // Add smooth transition effect\n    // Add styling for list items, if needed\n    .list-group-item {\n        margin: 5px;\n    }\n}\n\n.sidebar-button-divs {\n    background-color: #fff;\n    margin: 5px;\n    min-height: 45px;\n    border-radius: 4px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.sidebar-button-dropdown {\n    flex-direction: column;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
